import { createSlice } from '@reduxjs/toolkit';

import { IAdminAuthHeaders, IAdminUser } from '@/shared/types/admin-api';

export interface IAdminSessionState {
  auth: IAdminAuthHeaders | null;
  data: IAdminUser | null;
}

const initialState: IAdminSessionState = {
  auth: null,
  data: null
};

const adminSessionSlice = createSlice({
  name: 'adminSession',
  initialState,
  reducers: {
    /**
     * Обновление данных админской сессии
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Новые данные сессии
     */
    update: (state, { payload }: { payload: Partial<IAdminSessionState> }) => ({
      ...state,
      ...payload
    }),
    /** Сброс админской сессии */
    reset: () => initialState
  }
});

export const { reset: resetAdminSession, update: updateAdminSession } =
  adminSessionSlice.actions;
export const { reducer: adminSessionReducer } = adminSessionSlice;
